// @flow
import { connect } from 'react-redux';

import CardClubJoueur from 'components/fragments/card/CardClubJoueur';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/fragments/card/CardClubJoueur';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(CardClubJoueur);
